<script setup>
import { computed, ref } from 'vue';
import { useMapGetter, useStore } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Input from 'dashboard/components-next/input/Input.vue';

const { t } = useI18n();
const store = useStore();

const dialogRef = ref(null);
// The campaign comes in through open() rather than a prop: a prop set right before opening is
// still the previous campaign when the dialog reads it, and the field would seed the wrong name.
const campaign = ref(null);
const title = ref('');

const uiFlags = useMapGetter('campaigns/getUIFlags');
const isUpdating = computed(() => uiFlags.value.isUpdating);
const isInvalid = computed(() => !title.value.trim());

const open = campaignToRename => {
  campaign.value = campaignToRename;
  title.value = campaignToRename.title;
  dialogRef.value.open();
};

const handleDialogConfirm = async () => {
  try {
    await store.dispatch('campaigns/update', {
      id: campaign.value.id,
      title: title.value.trim(),
    });
    useAlert(t('CAMPAIGN.RENAME.API.SUCCESS_MESSAGE'));
    dialogRef.value.close();
  } catch (error) {
    useAlert(t('CAMPAIGN.RENAME.API.ERROR_MESSAGE'));
  }
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    :title="t('CAMPAIGN.RENAME.TITLE')"
    :confirm-button-label="t('CAMPAIGN.RENAME.CONFIRM')"
    :cancel-button-label="t('CAMPAIGN.RENAME.CANCEL')"
    :is-loading="isUpdating"
    :disable-confirm-button="isInvalid"
    @confirm="handleDialogConfirm"
  >
    <Input
      v-model="title"
      autofocus
      :label="t('CAMPAIGN.RENAME.LABEL')"
      :placeholder="t('CAMPAIGN.RENAME.LABEL')"
    />
  </Dialog>
</template>
